import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import ConsumerLayout from "@/components/consumer/ConsumerLayout";
import Home from "@/pages/consumer/Home";
import Explore from "@/pages/consumer/Explore";
import StudioDetail from "@/pages/consumer/StudioDetail";
import SessionDetail from "@/pages/consumer/SessionDetail";
import BookingConfirm from "@/pages/consumer/BookingConfirm";
import MyBookings from "@/pages/consumer/MyBookings";
import Credits from "@/pages/consumer/Credits";
import Profile from "@/pages/consumer/Profile";

import PartnerLayout from "@/components/partner/PartnerLayout";
import PartnerDashboard from "@/pages/partner/Dashboard";
import PartnerCalendar from "@/pages/partner/Calendar";
import PartnerSessions from "@/pages/partner/Sessions";
import PartnerBookings from "@/pages/partner/Bookings";
import PartnerPricing from "@/pages/partner/Pricing";
import PartnerCustomers from "@/pages/partner/Customers";
import PartnerFinance from "@/pages/partner/Finance";
import PartnerSettings from "@/pages/partner/Settings";

import AdminLayout from "@/components/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminUsers from "@/pages/admin/Users";
import AdminStudios from "@/pages/admin/Studios";
import AdminBookings from "@/pages/admin/Bookings";
import AdminCredits from "@/pages/admin/Credits";
import AdminApplications from "@/pages/admin/Applications";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<ConsumerLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/kesfet" element={<Explore />} />
            <Route path="/studyo/:id" element={<StudioDetail />} />
            <Route path="/seans/:id" element={<SessionDetail />} />
            <Route path="/rezervasyon/:sessionId" element={<BookingConfirm />} />
            <Route path="/rezervasyonlarim" element={<MyBookings />} />
            <Route path="/kredi" element={<Credits />} />
            <Route path="/profil" element={<Profile />} />
          </Route>

          <Route element={<PartnerLayout />}>
            <Route path="/partner" element={<PartnerDashboard />} />
            <Route path="/partner/takvim" element={<PartnerCalendar />} />
            <Route path="/partner/seanslar" element={<PartnerSessions />} />
            <Route path="/partner/rezervasyonlar" element={<PartnerBookings />} />
            <Route path="/partner/fiyatlandirma" element={<PartnerPricing />} />
            <Route path="/partner/musteriler" element={<PartnerCustomers />} />
            <Route path="/partner/finans" element={<PartnerFinance />} />
            <Route path="/partner/ayarlar" element={<PartnerSettings />} />
          </Route>

          <Route element={<AdminLayout />}>
            <Route path="/panel-yonetim" element={<AdminDashboard />} />
            <Route path="/panel-yonetim/kullanicilar" element={<AdminUsers />} />
            <Route path="/panel-yonetim/studyolar" element={<AdminStudios />} />
            <Route path="/panel-yonetim/rezervasyonlar" element={<AdminBookings />} />
            <Route path="/panel-yonetim/kredi-islemleri" element={<AdminCredits />} />
            <Route path="/panel-yonetim/basvurular" element={<AdminApplications />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
